/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductPurchaseService = {
  /**
   * Get Screen data
   *
   * */
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getBySupplierAndCode(code, supplier) {
    const requestScreenData = {
      url: "api/ProductPurchase",
      top: "1",
      filter: `ProductCode eq '${code}' and SupplierCode eq '${supplier}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { ProductPurchaseService };
